/**
 * Returns the entered key code
 */
export const getKeyCode = (e: KeyboardEvent) => {
    let code = e.keyCode ? e.keyCode : e.which;
    if (code === 189 || code === 173) {
        // For keydown events Special char i.e '-' gets changed/incremented.
        // '-' has keycode 45. But in Chrome it gets changed to 189 and in mozilla 173.
        // KeyCode and charCode are two different things that's why parsing anomaly.
        // For more: http://unixpapa.com/js/key.html -> Go to 'Symbol Keys' Section
        code = 45;
    }

    return code;
};

/**
 * Return if QRCode Prefix is pressed (ctrl + b)
 */
export const isQrCodePrefixPressed = (e: KeyboardEvent) => {
    const code = getKeyCode(e);
    return code === 66 && e.ctrlKey;
};

export const isShiftKey = (code: number) => {
    return code === 16;
};

export const isEnterKey = (code: number) => {
    return code === 13;
};

export const isIpadDevice = () => {
    return /ipad|iphone|ipad.*mobile/i.exec(window.navigator.userAgent);
};

/**
 * Check if x2-seller app running in the Xola tablet app (in the webview)
 */
export const isNativeTabletApp = () => {
    return window.navigator.userAgent.includes("XolaTablet");
};
